import { Box, Button, CardMedia, TextField, Typography } from "@mui/material";
import { HivePay } from "../../hivepay/hivepay";
import { useSelector } from "react-redux";
import { useState } from "react";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  borderRadius: "16px",
  background: "rgba(0,0,0,0.95)",
  border: "1px solid rgba(255,255,255,0.2)",
  boxShadow: "0 0 25px rgba(0,0,0,0.8)",
  p: 4,
};

const URL = "https://bigdogbone.up.railway.app";

export const Market = () => {
  const { informacion } = useSelector((state) => state.userSlice);
  const [open, setOpen] = useState(false);
  const [input, setinput] = useState(null);
  const [pack, setPack] = useState("");

  const handleOpen = (nombre) => {
    setPack(nombre);
    setOpen(true);
  };

  const handlebuy = () => {
    if (input > 0 && pack !== "") {
      const MONEDA =
        pack === "inicial"
          ? "SWAP.HIVE"
          : ["General Pack", "Hueso Fusion"].includes(pack)
          ? "HUESO"
          : "VIPHUESO";

      let cantidad = 0;
      switch (pack) {
        case "General Pack":
          cantidad = 2000 * input;
          break;
        case "Special Pack":
          cantidad = 50 * input;
          break;
        case "LVL":
          cantidad = 50 * input;
          break;
        case "inicial":
          cantidad = 50;
          break;
        case "Hueso Fusion":
          cantidad = 500 * input;
          break;
        default:
          cantidad = 2000 * input;
          break;
      }

      const json = {
        contractName: "tokens",
        contractAction: "transfer",
        contractPayload: {
          symbol: MONEDA,
          to: "mv-deposito",
          quantity: cantidad.toString(),
          memo: pack,
        },
      };

      const username = JSON.parse(sessionStorage.getItem("user"));

      window.hive_keychain.requestCustomJson(
        username.user,
        "ssc-mainnet-hive",
        "Active",
        JSON.stringify(json),
        "Transfer",
        function (response) {
          console.log(response);
        }
      );
    }
  };

  const handleClose = () => setOpen(false);

  const cardStyle = {
    m: 3,
    width: { xs: "140px", md: "170px" },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "16px",
    background: "rgba(0,0,0,0.5)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255,255,255,0.1)",
    boxShadow: "0 8px 20px rgba(0,0,0,0.6)",
    transition: "0.3s",
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "0 0 20px rgba(255,165,0,0.8)",
    },
    p: 2,
    zIndex: 1,
  };

  const buttonStyle = {
    width: "150px",
    mt: 1,
    background: "linear-gradient(45deg, #ff8c00, #ff3c00)",
    color: "#fff",
    fontWeight: "bold",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(255,140,0,0.7)",
    "&:hover": {
      background: "linear-gradient(45deg, #ff3c00, #ff8c00)",
      transform: "scale(1.05)",
    },
  };

  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(https://res.cloudinary.com/druu0mcam/image/upload/v1719339319/Diseño_sin_título_56_htku49_qnv3i1.png)`,
        backgroundSize: "cover",
        height: { xs: "100%", md: "91vh" },
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        alignItems: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.6)",
          zIndex: 0,
        },
      }}
    >
      {/* CARD TEMPLATE */}
      {[
        {
          name: "Initial Land",
          price: "100 - SWAP.HIVE",
          img: "https://res.cloudinary.com/druu0mcam/image/upload/v1719350153/image_3_xnh2qd.png",
          key: "inicial",
          disabled: informacion?.packInicial,
        },
        {
          name: "LVL UP",
          price: "50 - VIPHUESO",
          img: "https://res.cloudinary.com/druu0mcam/image/upload/v1719350908/image_5_yyryo8.png",
          key: "LVL",
        },
        {
          name: "General Pack",
          price: "2000 - HUESO",
          img: "https://res.cloudinary.com/druu0mcam/image/upload/v1719339873/Sobres_de_figuritas_rip5gr_dd2fd7_1_kyxwq0_psvtit.png",
          key: "General Pack",
        },
        {
          name: "Hueso Fusion",
          price: "500 - HUESO",
          img: "https://res.cloudinary.com/druu0mcam/image/upload/v1719339529/HUESOOROANIMADO_wpjjpv_y5y9ih.gif",
          key: "Hueso Fusion",
        },
        {
          name: "Special Pack",
          price: "50 VIPHUESO",
          img: "https://res.cloudinary.com/druu0mcam/image/upload/v1719339872/pack_special_cqkztw_1_ecp53e_qentqp.png",
          key: "Special Pack",
        },
      ].map((item, i) => (
        <Box key={i} sx={cardStyle}>
          <CardMedia
            component="img"
            sx={{
              width: "100%",
              borderRadius: "12px",
              mb: 1,
              transition: "0.3s",
              "&:hover": { transform: "scale(1.1)" },
            }}
            image={item.img}
          />

          <Typography
            sx={{
              color: "#fff",
              fontWeight: "bold",
              textAlign: "center",
              textShadow: "0 0 10px rgba(255,255,255,0.7)",
            }}
          >
            {item.name}
          </Typography>

          <Typography
            sx={{
              color: "#FFD700",
              fontWeight: "bold",
              textShadow: "0 0 8px gold",
            }}
          >
            {item.price}
          </Typography>

          <Button
            disabled={item.disabled}
            onClick={() => handleOpen(item.key)}
            sx={buttonStyle}
            variant="contained"
          >
            Buy
          </Button>
        </Box>
      ))}

      {/* MODAL */}
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography
            sx={{
              textAlign: "center",
              color: "#fff",
              fontWeight: "bold",
              mb: 2,
            }}
          >
            Choose the amount to buy
          </Typography>

          <TextField
            onChange={(e) => setinput(e.target.value)}
            value={input}
            fullWidth
            type="number"
            sx={{
              mb: 2,
              input: { color: "#fff" },
            }}
          />

          <Button onClick={handlebuy} fullWidth sx={buttonStyle}>
            Buy
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};